import {
  Flex,
  IconButton,
  Input,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { Field, NullableDateTypeDef } from '@micin-jp/chicken-schema'
// eslint-disable-next-line no-restricted-imports -- 新しいコンポーネントに置き換える
import { CalendarComponent } from 'src/components/__legacy__/form/calendar'
// eslint-disable-next-line no-restricted-imports -- 新しいアイコンに移行する
import { Calendar } from 'src/components/__legacy__/icon/monochrome'
import { colors } from 'src/lib/chakra-theme/foundations/colors'
import { zeroPadding } from 'src/utils/zeroPadding'

import { useWorksheetValueContext } from '../../context/WorksheetValue'
import { toDateString, toWorksheetDate, WorksheetDate } from '../../utils/date'
import { getErrorMessage } from '../../utils/getErrorMessage'
import { WorksheetFieldFormControl } from '../WorksheetFieldFormControl/WorksheetFieldFormControl'

type Props = {
  nullableDateField: Field & {
    typeDef: NullableDateTypeDef
  }
  index: number
}

export const WorksheetNullableDateField: React.FC<Props> = ({
  nullableDateField,
  index,
}) => {
  const {
    findFieldValue,
    onChangeNullableDateFieldValue,
    canEdit,
    isRepeatableSectionEnabled,
  } = useWorksheetValueContext()

  const value = findFieldValue({
    fid: nullableDateField.fid,
    index,
  })

  const date = toWorksheetDate(
    value?.type === 'nullableDate' ? value.nullableDateValue : undefined,
  )
  const onChangeNullableDateValue = (date: WorksheetDate) => {
    onChangeNullableDateFieldValue({
      fid: nullableDateField.fid,
      index,
      nullableDateValue: toDateString(date),
    })
  }

  const onChangeYear = (year: string) => {
    onChangeNullableDateValue({ ...date, year })
  }
  const onChangeMonth = (month: string) => {
    onChangeNullableDateValue({ ...date, month })
  }
  const onChangeDay = (day: string) => {
    onChangeNullableDateValue({ ...date, day })
  }

  const { isOpen, onOpen, onClose } = useDisclosure()

  const isDisabled =
    !canEdit(nullableDateField.typeDef) ||
    !isRepeatableSectionEnabled(index, nullableDateField.fid)
  return (
    <WorksheetFieldFormControl
      field={nullableDateField}
      index={index}
      isDisabled={isDisabled}
      errorMessage={getErrorMessage(value)}
    >
      <Stack display="inline-block" pos="relative" spacing="2">
        <Flex align="center">
          <Flex align="center" mr="4">
            <Input
              w="72px"
              mr="1"
              value={date.year}
              onChange={e => onChangeYear(e.target.value)}
            />
            <Text as="span" fontSize="sm" fontWeight="bold" mr="3">
              年
            </Text>
            <Input
              w="56px"
              mr="1"
              value={date.month}
              onChange={e => onChangeMonth(e.target.value)}
            />
            <Text as="span" fontSize="sm" fontWeight="bold" mr="3">
              月
            </Text>
            <Input
              w="56px"
              mr="1"
              value={date.day}
              onChange={e => onChangeDay(e.target.value)}
            />
            <Text as="span" fontSize="sm" fontWeight="bold">
              日
            </Text>
          </Flex>
          {!isDisabled && (
            <IconButton
              variant="customIconButtonGhost"
              colorScheme="blue"
              aria-label="calendar icon"
              icon={<Calendar color={colors.blue[500]} />}
              onClick={onOpen}
            />
          )}
        </Flex>
        {isOpen && (
          // アップロードファイルの画像と被るケースがあるため2を設定
          <Flex pos="absolute" right="0" zIndex="2">
            <CalendarComponent
              onChange={date => {
                onChangeNullableDateValue({
                  year: date.getFullYear().toString(),
                  month: zeroPadding((date.getMonth() + 1).toString(), 2),
                  day: zeroPadding(date.getDate().toString(), 2),
                })
              }}
              // onBlurでonValidation
              onClose={onClose}
            />
          </Flex>
        )}
      </Stack>
    </WorksheetFieldFormControl>
  )
}
